import React from 'react';
import EOEClaimsManager from './EOEClaimsManager';

const Billing: React.FC = () => <EOEClaimsManager />;

export default Billing;
